import { createAnimations } from '@tamagui/animations-css'

export const animations = createAnimations({
  '100ms': 'ease-in 100ms',
  bouncy: 'cubic-bezier(0.175, 0.885, 0.320, 1.275) 300ms',
  lazy: 'ease-in 400ms',
  medium: 'cubic-bezier(0.075, 0.820, 0.165, 1.000) 300ms',
  slow: 'ease-in 500ms',
  quick: 'ease-in 150ms',
  tooltip: 'ease-in-out 250ms',

  // Get rid of these
  normal: 'ease-in 200ms',
  'page-slide': 'cubic-bezier(0.165, 0.840, 0.440, 1.000) 500ms',
})
